import { NgModule, ModuleWithProviders } from '@angular/core';

import { IgoSharedModule } from '../shared';

import { QueryService, QueryDirective } from './shared';


@NgModule({
  imports: [
    IgoSharedModule
  ],
  exports: [
    QueryDirective
  ],
  declarations: [
    QueryDirective
  ]
})
export class IgoQueryModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: IgoQueryModule,
      providers: [
        QueryService
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/query/module.ts